import { ProductActions, GET_ACTIVE_PRODUCTS, GET_EXTENDED_PRODUCTS } from './types';
import { ActiveProduct } from '../../../models/ActiveProduct';
import { AppState } from '../index';
import { ExtendedProducts } from '../../../models/ExtendedProducts';
export interface IProductsState {
    activeProducts: ActiveProduct[] | undefined;
    extendedProducts?: ExtendedProducts;
}
export const INITIAL_STATE: IProductsState = { activeProducts: undefined, extendedProducts: undefined };

export default function(state = INITIAL_STATE, action: ProductActions) {
    switch (action.type) {
        case GET_ACTIVE_PRODUCTS:
            const { activeProducts } = action.payload;
            return { ...state, activeProducts };

        case GET_EXTENDED_PRODUCTS:
            const { extendedProducts } = action.payload;
            return { ...state, extendedProducts };

        default:
            return state;
    }
}
export const selectActiveProducts = (state: AppState): ActiveProduct[] | undefined => state?.products?.activeProducts;
export const selectExtendedProducts = (state: AppState): ExtendedProducts | undefined =>
    state?.products?.extendedProducts;
